import {useContext, useEffect, useState} from "react";
import './train.css';
import { PaymentContext } from "../Payments/PaymentContext";
import { useNavigate } from "react-router";
import {Button, Typography} from '@mui/material'

export default function BookTrains(){
    const [dataObtained, setDataObtained] = useState([]);
    const [date, setDate] = useState(new Date());
    const {setPrice, setSurcharge} = useContext(PaymentContext);
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();

    useEffect(()=>{
        window.scrollTo(0, 0);
        const url = 'https://content.newtonschool.co/v1/pr/63b85e152cabb8fdea2673ee/trains';
        fetch(url)
    .then((res)=>{
        res.json()
        .then((data)=>{
            setDataObtained(data);
            setLoader(false);
        })
    })
    } , [])
    return (
       <>
       {loader ? <div className="loader" >
        <img src="/loader.gif" style={{width:'100px', height:'100px'}}/>
       </div> : <>
       <h3 style={{marginLeft: '16vw'}}>Available Train Tickets</h3>
        <div className="ticket-container">
            {dataObtained.map((el, idx)=>{
                return (
                    <div className="tkt-box3" key={idx}>
                        <table>
                            <tr>
                                <td>FROM</td>
                                <td>DEPARTURE</td>
                                <td>PRICE</td>
                            </tr>
                            <tr>
                                <td><Typography 
                                variant="h4"
                                sx={{lineHeight:0.5}}
                                >{el.from}</Typography></td>
                                <td><h4>{el.departure.departureTime}|{date.getDate()}-{date.getMonth()}-{date.getFullYear()}</h4></td>
                                <td>{el.price}</td>
                            </tr>
                            <tr>
                                <td>To</td>
                                <td>TRAIN NUMBER</td>
                                <td>KILOMETERS</td>
                            </tr>
                            <tr>
                                <td><Typography
                                variant="h4"
                                sx={{lineHeight:0.5}}
                                >{el.to}</Typography></td>
                                <td><h4>{el.train_number}</h4></td>
                                <td>{el.kilometers}</td>
                            </tr>
                            <tr>
                                <td>Duration:</td>
                            </tr>
                            <tr>
                                <td><h4>{el.duration}</h4></td>
                            </tr>
                        </table>
                        <Button 
                        variant="contained"
                        sx={{float:'right', marginBottom:'20px', marginRight:'20px'}}
                        id={el.price} 
                        onClick={(e)=>{
                            e.persist();
                            setPrice(parseInt(e.currentTarget.id));
                            setSurcharge(parseInt(e.currentTarget.id)*0.25);
                            navigate('/payments');
                        }
                        }>BOOK</Button>
                    </div>
                )
            })}
        </div>
       </>
       }
       </> 
    )
}